import { DailyClaimDialog } from 'components/rewards/DailyClaimDialog';

const DailyClaimPage = () => {
  return <DailyClaimDialog open onClose={() => {}} />;
};
export default DailyClaimPage;
